import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-relative tw-h-full tw-w-full tw-rounded-2xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "tw-w-full tw-h-full tw-max-h-full tw-rounded-2xl tw-z-0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { JobsState } from "@/core/models/jobs";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { computed, onMounted, watch } from "vue";
import mapMarkerImage from "@/core/uni-assets/images/map-marker.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'JobMap',
  props: {
  data: {
    type: Object as () => JobsState["jobs"],
    required: true,
  },
},
  setup(__props) {

const props = __props;

const mapData = computed(() => props.data);

let map: L.Map;

let markersLayer = new L.LayerGroup();

const updateMap = (data: JobsState["jobs"]) => {
  // NOTE: The first thing we do here is clear the markers from the layer.
  markersLayer.clearLayers();

  const locationCoor = [];
  let marker: any;

  const customIcon = {
    iconUrl: mapMarkerImage,
    iconSize: [20, 40],
  };

  const mapIcon = L.icon(customIcon);

  for (let i = 0; i < data.length; i++) {
    const iconProps = {
      title: data[i].name,
      clickable: true,
      icon: mapIcon,
    };

    const lat = parseFloat(data[i].latitude);
    const lon = parseFloat(data[i].longitude);

    if (lat && lon) {
      locationCoor[i] = [lat, lon];

      const popup = L.popup().setLatLng([lat, lon]).setContent(`
      <h1>${data[i].name}</h1>
      <p>${data[i].postcode}</p>
      <p>${data[i].description}</p>
    `);

      marker = L.marker([lat, lon], iconProps).bindPopup(popup);

      markersLayer.addLayer(marker);
    }
  }

  if (locationCoor.length > 0) {
    const bounds = new L.latLngBounds(locationCoor);
    map.fitBounds(bounds, { padding: [50, 50] });
  }
};

onMounted(() => {
  map = L.map("map", {
    zoomControl: false,
  }).setView([51.3593966, -0.2863208], 12);
  L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  }).addTo(map);
  markersLayer.addTo(map);
  // Initialize mapMarkers

  updateMap(mapData.value);
});

watch(
  mapData,
  (state) => {
    updateMap(state);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})